module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "pagination-wrap text-left"
  }, [((_vm.totalPages > 1)) ? _c('ul', {
    staticClass: "pagination"
  }, [(_vm.hasPrev()) ? _c('li', {
    staticClass: "pagination__left",
    class: {
      disabled: !_vm.hasPrev()
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.prevPage)
      }
    }
  }, [_vm._v("Prev")])]) : _vm._e(), _vm._v(" "), (_vm.hasFirst()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(1)
      }
    }
  }, [_vm._v("1")])]) : _vm._e(), _vm._v(" "), (_vm.hasFirst()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      key: page,
      class: {
        active: _vm.currentPage == page
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changePage(page)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page) + "\n      ")])])
  }), _vm._v(" "), (_vm.hasLast()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.hasLast()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.totalPages)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.totalPages) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pagination__right"
  }, [(_vm.hasNext()) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.nextPage)
      }
    }
  }, [_vm._v("Next")]) : _vm._e()])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16151a9f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/Pager.vue
// module id = 825
// module chunks = 0